import { UAParser as uaParser } from 'ua-parser-js';

export const getDeviceBrowser = (): string | undefined => {
    const UAParser = new uaParser();

    const userAgent = window.navigator.userAgent;
    const browserData = UAParser.setUA(userAgent).getBrowser();

    return browserData?.name;
};
